import { AnyAction } from 'redux';

import { tokenDataState, tokenDataActions } from './tokenData.types';

export const tokenDataInitialState: tokenDataState = {};

export const tokenDataReducer: (state: tokenDataState | undefined, action: AnyAction) => tokenDataState = (
	state = tokenDataInitialState,
	action
): tokenDataState => {
	if (action.type === tokenDataActions.saveTokenData) {
		return {
			...state,
			...action.payload,
		};
	}
	return state;
};
